import { Route } from "@angular/router";
import { AuthGuard } from "@grainger/angular/guards/auth.guard";
import { ForbiddenComponent } from "./forbidden/forbidden.component";

export const appRoutes: Route[] = [
    {
        path: "auth",
        loadChildren: () => import("./auth/auth.routes").then((r) => r.routes),
        canActivate: [AuthGuard.canActivateUnauthenticated]
    },
    {
        path: "users",
        loadChildren: () => import("./users/users.routes").then((r) => r.routes),
        canActivate: [AuthGuard.canActivateAuthenticated, AuthGuard.canActivateAsUserAdmin]
    },
    {
        path: "roadmaps",
        loadChildren: () => import("./facilities/facilities.routes").then((r) => r.routes),
        canActivate: [AuthGuard.canActivateAuthenticated, AuthGuard.canActivateAsSuperadmin]
    },
    {
        path: "report",
        loadChildren: () => import("./report/report.routes").then((r) => r.routes),
        canActivate: [AuthGuard.canActivateAuthenticated, AuthGuard.canActivateAsUserAdmin]
    },
    {
        path: "email-domains",
        loadChildren: () => import("./email-domains/email-domains.routes").then((r) => r.routes),
        canActivate: [AuthGuard.canActivateAuthenticated, AuthGuard.canActivateAsSuperadmin]
    },
    {
        path: "forbidden",
        component: ForbiddenComponent,
        canActivate: [AuthGuard.canActivateAuthenticated]
    },
    {
        path: "**",
        redirectTo: "users"
    }
];
